import { call, put, takeEvery } from "redux-saga/effects"
import { hinhThucMienGiamGroupApi } from "../../api/hinhThucMienGiamGroupApi"
import { IBaseResponeModel } from "../../models/response/base-response"
import { HinhThucMienGiamGroupActionTypeIds, HinhThucMienGiamGroupDeleteStartAction, HinhThucMienGiamGroupSaveStartAction } from "../action-types/hinhThucMienGiamGroupActionTypes"
import {
    deleteHinhThucMienGiamGroupError,
    deleteHinhThucMienGiamGroupSuccess,
    loadHinhThucMienGiamGroupError, loadHinhThucMienGiamGroupSuccess, saveHinhThucMienGiamGroupError, saveHinhThucMienGiamGroupSuccess
} from "../actions/hinhThucMienGiamGroupActions"
export function* hinhThucMienGiamGroupSaga(): any {
    yield takeEvery(HinhThucMienGiamGroupActionTypeIds.HINHTHUCMIENGIAMGROUP_LOAD_START, loadHinhThucMienGiamGroupStartWorker)
    yield takeEvery(HinhThucMienGiamGroupActionTypeIds.HINHTHUCMIENGIAMGROUP_SAVE_START, saveHinhThucMienGiamGroupStartWorker)
    yield takeEvery(HinhThucMienGiamGroupActionTypeIds.HINHTHUCMIENGIAMGROUP_DELETE_START, deleteHinhThucMienGiamGroupStartWorker)
}
function* loadHinhThucMienGiamGroupStartWorker() {
    const res: IBaseResponeModel = yield call(hinhThucMienGiamGroupApi.selectAll)
    if (res.is_success) {
        yield put(loadHinhThucMienGiamGroupSuccess(res.data))
    } else {
        yield put(loadHinhThucMienGiamGroupError(res.message || ""))
    }
}
function* saveHinhThucMienGiamGroupStartWorker(data: HinhThucMienGiamGroupSaveStartAction) {
    let res: IBaseResponeModel;
    if (data.payload.id > 0) {
        res = yield call(hinhThucMienGiamGroupApi.update, data.payload)
    } else {
        res = yield call(hinhThucMienGiamGroupApi.insert, data.payload)
    }

    if (res.is_success) {
        yield put(saveHinhThucMienGiamGroupSuccess(data.payload))
        yield call(loadHinhThucMienGiamGroupStartWorker)
    } else {
        yield put(saveHinhThucMienGiamGroupError(res.message || ""))
    }
}
function* deleteHinhThucMienGiamGroupStartWorker(data: HinhThucMienGiamGroupDeleteStartAction) {
    const res: IBaseResponeModel = yield call(hinhThucMienGiamGroupApi.delete, data.payload)
    if (res.is_success) {
        yield put(deleteHinhThucMienGiamGroupSuccess(data.payload))
        yield call(loadHinhThucMienGiamGroupStartWorker)
    } else {
        yield put(deleteHinhThucMienGiamGroupError(res.message || ""))
    }
}